<template>
  <div />
</template>

<style lang="scss" scoped>
div {
  width: 2rem;
  height: 2rem;
  border: 0.25rem solid $highlight-500;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 750ms linear infinite;
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style>
